define.alias("shared/components/shared/mobile/open-app", "calendar/components/shared/mobile/open-app");